import React from 'react';
import { observer } from 'mobx-react-lite';
import FirmConfirmation from '../FirmConfirmation';
import strings from '../../strings';
import FilterIcon from '../FilterIcon';

const VerifiedProfileIcon = ({ firmTypeAbbreviation, verified, handleVerifiedClick }) => {
  const verifiedProfileIcon = (
    <FirmConfirmation firmTypeAbbreviation={firmTypeAbbreviation} />
  );

  const verifiedProfileText = strings.verifiedProfile;

  return (
    <FilterIcon
      icon={verifiedProfileIcon}
      iconSelected={verifiedProfileIcon}
      text={verifiedProfileText}
      pressed={verified}
      handleClick={handleVerifiedClick}
    />
  );
};

export default observer(VerifiedProfileIcon);
